import { Package, Shapes, DollarSign } from 'lucide-react';
import { getEntityIconComponent } from '../../../config/modules.config';
import type { ModuleSetupConfig } from '../types';

// `create_family` was renamed to `create_category`: it pointed at
// `/master-data/families`, which has no route — the catalog groups products by
// category, and that is what the products dashboard already fetches.
export const productsSetupConfig: ModuleSetupConfig = {
  moduleId: 'products',
  i18nNamespace: 'products',
  steps: [
    {
      id: 'create_product',
      type: 'action',
      icon: Package,
      titleKey: 'products:dashboard.setup.createProductTitle',
      descriptionKey: 'products:dashboard.setup.createProductDesc',
      actionLabelKey: 'products:dashboard.setup.createProduct',
      actionPath: '/master-data/products',
      tone: 'info',
      isComplete: (data) => (data.total_products as number) > 0,
    },
    {
      id: 'create_category',
      type: 'action',
      // The product_category entity's own glyph, resolved from the registry so
      // this step cannot drift from the page it links to (WI bbb2fcf4).
      icon: getEntityIconComponent('product_categories') ?? Shapes,
      titleKey: 'products:dashboard.setup.createCategoryTitle',
      descriptionKey: 'products:dashboard.setup.createCategoryDesc',
      actionLabelKey: 'products:dashboard.setup.createCategory',
      actionPath: '/master-data/categories',
      tone: 'success',
      isComplete: (data) => (data.total_categories as number) > 0,
    },
    {
      id: 'create_price_list',
      type: 'action',
      icon: DollarSign,
      titleKey: 'products:dashboard.setup.createPriceListTitle',
      descriptionKey: 'products:dashboard.setup.createPriceListDesc',
      actionLabelKey: 'products:dashboard.setup.createPriceList',
      actionPath: '/master-data/price-lists',
      dependsOn: ['create_product'],
      tone: 'accent',
      isComplete: (data) => (data.total_price_lists as number) > 0,
    },
  ],
};
